<template lang="html">
	<vddl-draggable class="panel__body--item group"
					:draggable="item"
					:index="index"
					:wrapper="list"
					:type="type"
          :disable-if="true"
					:moved="handleMovedList">
    <div class="attribute condition" v-if="item">
      <span class="fa fa-ellipsis-v drag"></span>
      <template v-if="!itemStructure[item.attribute]">
        {{ item.attribute }}
      </template>
      <template v-else>
        {{( $t(itemStructure[item.attribute].title) || itemStructure[item.attribute].title) }}
      </template>
      <span class="fa fa-trash attribute_editable_trash" title="Delete" @click="deleteCondition()"></span>
      <br/>
      <span>{{'{' + item.attribute + '}'}}</span>
      <br>
      <hr style="margin: 10px 0;">
      <div>
        <textarea :class="errorTextarea ? 'error' : ''" class="input" cols="15" rows="5" v-model="valueTextarea"></textarea>
        <span v-if="getType === 'B'">Input <b>true</b> or <b>false</b> without quote.</span>
        <span v-if="getType === 'D' || (getType === 'S' && isMultiple) || (getType === 'L' && isMultiple) || (getType === 'N' && isMultiple) || getType === 'NM'">Not supported.</span>
        <span v-if="getType === 'L' && !isMultiple">Enter code of classificators without quote.</span>
        <span v-if="getType === 'N' && !isMultiple">Input only of floating-point numbers is supported.</span>
      </div>
    </div>
	</vddl-draggable>
</template>

<script>
export default {
	name: 'list-condition',
	data () {
		return {
			type: 'list',
      errorTextarea: false
		}
	},
  props: [
		'item',
		'list',
		'index',
		'localization',
		'itemStructure',
		'dropzones',
		'toggleInputEdit'
	],
  computed: {
    getType () {
      if (this.dropzones.condition) {
        return this.itemStructure[this.dropzones.condition.attribute].type
      }
      return null;
    },
    isMultiple () {
      if (this.dropzones.condition) {
        return this.itemStructure[this.dropzones.condition.attribute].multiple
      }
      return false;
    },
    valueTextarea: {
      get () {
        const value = this.dropzones.condition?.value;
        const type = this.getType;
        const multiple = this.isMultiple;

        if (value === undefined || value === null) {
          if (type === 'B') return 'true';
          if (type === 'N') return multiple ? '["number", "number"]' : 'number';
          if (type === 'S') return multiple ? '["string", "string"]' : 'string';
          if (type === 'NM') return multiple ? '[ {"val": "number", "mu": "GR" }]' : '{"val": "number", "mu": "GR"}';
          if (type === 'SL') return '{"EE": "string", "EN": "string", "LV": "string"}';
          if (type === 'L') return multiple ? '["string", "string"]' : 'string';
          if (type === 'D') return '2025-06-04';
          return '';
        }

        if (typeof value === 'object') {
          return JSON.stringify(value);
        }

        return String(value);
      },
      set(val) {
        const type = this.getType;
        const multiple = this.isMultiple;

        try {
          if (type === 'NM' || type === 'SL' || multiple) {
            this.dropzones.condition.value = JSON.parse(val);
          } else if (type === 'B') {
            this.dropzones.condition.value = val === 'true'
          } else if (type === 'N') {
            this.dropzones.condition.value = Number(val)
          } else {
            this.dropzones.condition.value = val;
          }
        } catch (e) {
          this.dropzones.condition.value = val;
        }
      }
    }
  },
	methods: {
		handleMovedList (item) {

		},
    deleteCondition () {
      this.dropzones.condition = null
    },
    setValue(event) {
      let value = event.target.value;
      const type = this.getType

      if (type === 'NM' || type === 'SL' || this.isMultiple) {
        try {
          const parsed = JSON.parse(value);
          this.$set(this.dropzones.condition, 'value', parsed);
        } catch (e) {
          this.$set(this.dropzones.condition, 'value', value);
        }
      } else {
        this.$set(this.dropzones.condition, 'value', value);
      }
    }
  },
	created () {

	}
}
</script>

<style lang="scss">
.attribute {
	position: relative;
	&:hover &_editable_unlock {
		display: block;
	}

  &:hover &_editable_copy {
    display: block;
  }

  &:hover &_editable_trash {
    display: block;
  }

	&:hover &_editable_unlock_label {
		display: block;
	}

	%editable_shared {
		position: absolute;
    top: 10px;
		padding: 5px;
		border-radius: 50%;
		background-color: #f5f5f5;
		&:hover {
			cursor: pointer;
		}
	}

	%editable_shared_label {
		position: absolute;
		top: 2px;
		right: 25px;
	}

	&_editable_unlock {
		display: none;
    right: 27px;
		@extend %editable_shared
	}

	&_editable_lock {
    right: 27px;
		@extend %editable_shared
	}

	&_editable_unlock_label {
		display: none;
		@extend %editable_shared_label
	}

	&_editable_lock_label {
		@extend %editable_shared_label
	}

  &_editable_copy {
    display: none;
    right: 53px;
    @extend %editable_shared;
  }

  &_editable_trash {
    display: none;
    right: 0;
    color: #ff00008a;
    @extend %editable_shared;
  }
}
.condition {
  &:hover {
    cursor: default;
  }
  .input {
    width: 100%;
    padding: 0 5px;
    border-radius: 2px;
    border: 1px solid #ababab;
    &:focus {
      outline: none;
    }
  }
}

.error {
  border-color: #ff00008a !important;
}
</style>
